/* ELIO cart push.
   Runs as an external asset (inline section scripts are blocked on this theme —
   same reason elio-ship-strip.js is external).
   Reads its config from data- attributes on [data-elio-cart-push] in
   sections/header.liquid, and anchors a small card under the header cart button
   (#headerCartStatus). The header renders on every page, so this persists
   site-wide except /cart and /checkout.

   Shows when the cart has 2+ items. No pair math. No scarcity claims.
   Carries: the actual cart thumbnails, the dispatch line, the replace-it line.

   The dispatch line promises only what ELIO controls: the SHIP day, never the
   arrival. It mirrors elio-ship-countdown's settings (same source of truth):
     before cutoff on a ship day -> "Order now, ships today"
     after cutoff                -> "Ships tomorrow"
     next ship day further out   -> "Ships Monday" (real weekday name)
   If settings.elio_ship_enabled is off, the line does not render at all and the
   card still works (thumbnails + risk line + CTA). Fails silent. */
(function () {
  if (window.__ELIO_CP__) return;
  window.__ELIO_CP__ = true;

  function run() {
    // Never on the cart or checkout: they're already there, and the CTA just routes to /cart.
    // Locale-prefixed paths (/es/cart) match too.
    if (/\/(cart|checkout)(\/|$|\?)/.test(location.pathname)) return;

    var cfg = document.querySelector('[data-elio-cart-push]');
    if (!cfg) return;

    var CTA    = cfg.getAttribute('data-cta') || 'Checkout';
    var ALTCTA = cfg.getAttribute('data-alt-cta') || 'Review cart';
    var RISK   = cfg.getAttribute('data-risk') || '';
    var LOCALE = cfg.getAttribute('data-locale') || 'en';

    // Possessive line pieces — locale-driven so the phrasing localises without
    // touching this file. This card only ever shows at 2+ items, so the plural
    // is always correct and there's no singular form to carry.
    var OWN_ONE  = cfg.getAttribute('data-own-one')  || 'Your [colors] briefs.';
    var OWN_MANY = cfg.getAttribute('data-own-many') || 'Your [count] briefs.';
    var OWN_AND  = cfg.getAttribute('data-own-and')  || 'and';

    var SHIP_ON = cfg.getAttribute('data-ship-enabled') !== '0';
    var T_LOW   = cfg.getAttribute('data-low-stock') || '';
    var T_OTHER = cfg.getAttribute('data-others') || '';
    var LOW_MAX = parseInt(cfg.getAttribute('data-low-threshold'), 10);
    if (isNaN(LOW_MAX)) LOW_MAX = 6;

    // Colorways are separate products, so /cart.js can't report stock.
    // The real inventory_quantity map is rendered from Liquid in header.liquid.
    var STOCK = {};
    try { STOCK = JSON.parse(document.getElementById('elioCpStock').textContent) || {}; } catch (e) {}

    // On a PDP, [data-product-variants] is the same live map the availability meter
    // reads. Merge it over the header map so this and the meter never disagree.
    function mergeLiveVariants() {
      var el = document.querySelector('[data-product-variants]');
      if (!el) return;
      try {
        var list = JSON.parse(el.textContent) || [];
        for (var i = 0; i < list.length; i++) {
          var v = list[i];
          if (!v || v.id == null) continue;
          var prev = STOCK[String(v.id)] || {};
          STOCK[String(v.id)] = {
            q: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : prev.q,
            m: v.inventory_management,
            p: v.inventory_policy,
            s: prev.s
          };
        }
      } catch (e) {}
    }
    var T_TODAY = cfg.getAttribute('data-ships-today') || '';

    var WD_CUTOFF  = parseInt(cfg.getAttribute('data-weekday-cutoff'), 10);
    var SAT_ON     = cfg.getAttribute('data-sat-enabled') !== '0';
    var SAT_CUTOFF = parseInt(cfg.getAttribute('data-sat-cutoff'), 10);
    if (isNaN(WD_CUTOFF)) WD_CUTOFF = 14;
    if (isNaN(SAT_CUTOFF)) SAT_CUTOFF = 13;

    var OFF = 'elio_cp_off', LAST = 'elio_cp_last';

    // ---- reservation timer -------------------------------------------------
    // A soft "reserved for you" countdown. It NEVER clears the cart or touches
    // inventory — purely a visual hold, so abandoned-cart flows stay armed.
    // At zero the line flips to "others are buying your size".
    var RESV_ON      = cfg.getAttribute('data-reserve-enabled') === '1';
    var RESV_PREVIEW = cfg.getAttribute('data-reserve-preview') === '1';
    var RESV_MIN     = parseInt(cfg.getAttribute('data-reserve-minutes'), 10);
    if (isNaN(RESV_MIN)) RESV_MIN = 15;
    var RESV_RESURF  = parseInt(cfg.getAttribute('data-reserve-resurface-at'), 10);
    if (isNaN(RESV_RESURF)) RESV_RESURF = 0;
    var RESV_LABEL   = cfg.getAttribute('data-reserve-label') || 'Reserved';
    var RESV_CUE     = cfg.getAttribute('data-reserve-cue') || 'Cart reserved for';
    var RESV_EXPIRED = cfg.getAttribute('data-reserve-expired') || 'Others are buying your size.';
    var TOTAL_LABEL  = cfg.getAttribute('data-total-label') || 'Subtotal';
    // Persistent per-session start time, so the countdown is ONE continuous timer
    // across page loads (never a per-page restart, which would read as fake).
    var RESV_START = 'elio_cp_resv_start';   // ms epoch the countdown began
    var RESV_SEEN  = 'elio_cp_resv_sliver';  // (legacy, unused) once-fired marker
    var SLIVER_OFF = 'elio_cp_sliver_off';   // '1' once the user closes the sliver
    var RESV_DUR   = RESV_MIN * 60 * 1000;    // total countdown in ms

    function ss(k)      { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k,v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    function ssDel(k)   { try { sessionStorage.removeItem(k); } catch (e) {} }
    // localStorage variants: sessionStorage is PER-TAB, so a value written in one
    // tab is invisible to another — which made the countdown restart on every tab.
    // The reservation start-time uses these so it's one continuous clock everywhere.
    function ls(k)      { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k,v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function lsDel(k)   { try { localStorage.removeItem(k); } catch (e) {} }
    function off()      { return ss(OFF) === '1'; }

    function dcode() {
      var el = document.querySelector('[data-discount-code]');
      var d = el ? (el.getAttribute('data-discount-code') || '').trim() : '';
      if (d) { try { localStorage.setItem('elio_active_discount_code', d); } catch (e) {} return d; }
      try { return localStorage.getItem('elio_active_discount_code') || ''; } catch (e) { return ''; }
    }
    function cartUrl() {
      var c = dcode();
      return c ? '/discount/' + encodeURIComponent(c) + '?redirect=/cart' : '/cart';
    }
    /* The drawer carries the live cart, so it replaces the /cart trip entirely.
       If a discount code is pending it has to be claimed by URL first — the
       drawer can't apply one — so that case still navigates. */
    function openCartDrawer(opener) {
      if (dcode()) { location.href = cartUrl(); return; }
      var drawer = document.getElementById('shtCartDrawer') || document.querySelector('sht-cart-drwr');
      if (drawer && typeof drawer.openDrawer === 'function') {
        try { drawer.openDrawer(opener || null); return; } catch (e) {}
      }
      location.href = cartUrl();
    }

    function checkoutUrl() {
      var c = dcode();
      return c ? '/discount/' + encodeURIComponent(c) + '?redirect=/checkout' : '/checkout';
    }
    /* Straight to checkout, but never around the size-review gate. The gate only
       intercepts clicks, so a location.assign() would slip past it — route through
       its public guard(). Falls back to navigating directly if it isn't loaded. */
    function goGuarded(url) {
      if (window.elioSizeGate && typeof window.elioSizeGate.guard === 'function') {
        window.elioSizeGate.guard(function () { location.href = url; });
      } else {
        location.href = url;
      }
    }

    // ---- federal / USPS holidays, computed from the rules ------------------
    // Works for any year, forever. No table, nothing to expire.
    function ymd(d) {
      var m = d.getMonth() + 1, day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }
    var _hol = {};
    function nthDow(y, m, dow, n) {
      var d = new Date(y, m, 1);
      d.setDate(1 + ((dow - d.getDay() + 7) % 7) + (n - 1) * 7);
      return d;
    }
    function lastDow(y, m, dow) {
      var d = new Date(y, m + 1, 0);
      d.setDate(d.getDate() - ((d.getDay() - dow + 7) % 7));
      return d;
    }
    function obs(d) {                     // fixed-date: Sat -> Fri before, Sun -> Mon after
      var w = d.getDay();
      if (w === 6) return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
      if (w === 0) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
      return d;
    }
    function holidaysFor(y) {
      if (_hol[y]) return _hol[y];
      var list = [
        obs(new Date(y, 0, 1)), nthDow(y, 0, 1, 3), nthDow(y, 1, 1, 3), lastDow(y, 4, 1),
        obs(new Date(y, 5, 19)), obs(new Date(y, 6, 4)), nthDow(y, 8, 1, 1),
        nthDow(y, 9, 1, 2), obs(new Date(y, 10, 11)), nthDow(y, 10, 4, 4), obs(new Date(y, 11, 25))
      ];
      var map = {};
      for (var i = 0; i < list.length; i++) map[ymd(list[i])] = 1;
      map[ymd(obs(new Date(y + 1, 0, 1)))] = 1;
      _hol[y] = map;
      return map;
    }
    function isHoliday(d) { return !!holidaysFor(d.getFullYear())[ymd(d)]; }

    // ---- ship day: the only thing ELIO controls, so the only thing promised
    function etNow() {
      try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); }
      catch (e) { return new Date(); }
    }
    function isShipDay(d) {
      var w = d.getDay();
      if (w === 0) return false;                 // no Sunday dispatch
      if (w === 6 && !SAT_ON) return false;
      return !isHoliday(d);
    }
    function cutoffFor(d) { return d.getDay() === 6 ? SAT_CUTOFF : WD_CUTOFF; }

    // Slot 2: only fires while today's dispatch is still catchable.
    // "Ships tomorrow" is NOT urgency (waiting costs nothing), so it falls through
    // to the default rather than occupying the line with a limp fact.
    function shipLine() {
      if (!SHIP_ON) return '';                   // toggle off -> promise nothing
      var now = etNow();
      if (isShipDay(now) && now.getHours() < cutoffFor(now)) return T_TODAY;
      return '';
    }

    // ---- cart --------------------------------------------------------------
    var count = 0, items = [], box = null;
    var cartTotal = null, cartCurrency = 'USD';
    var cartSavedTotal = 0, cartSavedNames = [];

    // Format cents -> localized currency. Uses Intl when available; the total is
    // cart.total_price, which already reflects line-level bundle pricing. We label
    // it "Subtotal" (not "Total") because order-level auto-discounts may only land
    // at checkout — subtotal is truthful in every case.
    /* Whole amounts print clean; anything else gets exactly two places. The
       previous formatter trimmed trailing zeros, so $106.20 rendered as
       $106.2 — wrong for money anywhere it appears. */
    function money(cents) {
      if (typeof cents !== 'number') return '';
      var v = cents / 100;
      var body = (v % 1 === 0) ? String(v) : v.toFixed(2);
      try {
        var sym = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cartCurrency })
          .formatToParts(0).filter(function (x) { return x.type === 'currency'; })
          .map(function (x) { return x.value; }).join('') || '$';
        return sym + body;
      } catch (e) { return '$' + body; }
    }

    // The theme's own cart notification (#cartNotificationPanel) fires on add and
    // auto-dismisses. We avoid stacking ON it, but must never let a stuck/missing
    // notification permanently hide the push. Treat it as "open" only for a short
    // grace window after it actually appears; after that, show regardless.
    var notifSeenOpenAt = 0;
    function notifOpen() {
      var n = document.getElementById('cartNotificationPanel');
      var open = !!(n && !n.hasAttribute('hidden'));
      if (open) {
        if (!notifSeenOpenAt) notifSeenOpenAt = Date.now();
        return (Date.now() - notifSeenOpenAt) < 6000;
      }
      notifSeenOpenAt = 0;
      return false;
    }

    function showable() { return count >= 2 && !notifOpen(); }   // 2+ items. no pair math.

    // Slot 1: the scarcest variant THEY chose, only when genuinely low.
    // Untracked inventory makes no claim.
    // Colourways are separate products ("Navy Cotton Brief"), so the colour is the
    // first word of the product title and the size is the variant title.
    function colourOf(item) {
      return String(item.product_title || '').trim().split(/\s+/)[0] || '';
    }
    // Same test the PDP availability meter uses: tracked AND not oversellable.
    function isTracked(r) {
      return !!(r && r.m && r.p !== 'continue');
    }
    function lowLine() {
      var low = null;
      for (var i = 0; i < items.length; i++) {
        var id = items[i].variant_id != null ? items[i].variant_id : items[i].id;
        var r = STOCK[String(id)];
        if (!isTracked(r)) continue;
        if (typeof r.q !== 'number') continue;
        if (r.q > 0 && (!low || r.q < low.q)) low = { q: r.q, s: r.s || items[i].variant_title, c: colourOf(items[i]) };
      }
      if (!low || low.q > LOW_MAX) return '';
      var variant = (low.c ? low.c + ' ' : '') + (low.s || '');
      return T_LOW.replace('[n]', low.q).replace('[variant]', variant.trim());
    }

    // The nudge fires ONLY when something is genuinely time-sensitive — real low
    // stock on their size, or today's dispatch. No default: the claim headline
    // carries the always-on message, so the nudge stays silent unless it bites.
    function urgencyLine() {
      return lowLine() || shipLine();
    }

    // Emphasis: the colourways and the numeral are the personal, variable part,
    // so they get their own span to carry more weight. Merchant-controlled titles,
    // but escaped anyway since this now goes through innerHTML.
    function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
    function hl(s){ return '<span class="elio-cp__hl">' + esc(s) + '</span>'; }

    // The personalized hero line — reflects the cart back to him as HIS object.
    // Thinks across every real cart state:
    //   1 colour           -> "Your Crimson briefs."        (Crimson bold)
    //   2 colours          -> "Your Navy and Crimson briefs." (Navy, Crimson bold)
    //   3+ colours         -> "Your 6 briefs."              (6 bold; names -> scale)
    //   same colour x2..n  -> dedupes to one colour
    //   mixed quantities   -> colour identity only, no per-colour counts
    // [count] is total units, not colour count.
    function ownLine() {
      var seen = {}, cols = [], qty = 0;
      for (var i = 0; i < items.length; i++) {
        qty += (+items[i].quantity || 1);
        var c = colourOf(items[i]), k = c.toLowerCase();
        if (c && !seen[k]) { seen[k] = 1; cols.push(c); }
      }
      if (!qty) return '';
      if (cols.length >= 3 || cols.length === 0) {
        return OWN_MANY.replace('[count]', hl(String(qty)));
      }
      var list = (cols.length === 2) ? (hl(cols[0]) + ' ' + OWN_AND + ' ' + hl(cols[1])) : hl(cols[0]);
      return OWN_ONE.replace('[colors]', list);
    }

    function thumbs() {
      var o = [], seen = {}, n = 0;
      for (var i = 0; i < items.length && n < 2; i++) {
        // one thumbnail per distinct colourway, so the images mirror the claim
        // ("Tan & Crimson") instead of repeating whichever colour comes first.
        var c = (colourOf(items[i]) || '').toLowerCase();
        if (c && seen[c]) continue;
        var src = items[i].image || (items[i].featured_image && items[i].featured_image.url);
        if (!src) continue;
        if (c) seen[c] = 1;
        var alt = ((items[i].product_title || '') + ' ' + (items[i].variant_title || '')).replace(/"/g, '').trim();
        o.push('<img src="' + (src.indexOf('?') > -1 ? src : src + '?width=120') + '" alt="' + alt + '">');
        n++;
      }
      return o.join('');
    }

    function anchor() {
      if (!box) return;
      var b = document.getElementById('headerCartStatus');
      var vw = window.innerWidth;
      var w = box.offsetWidth || 160;
      if (b) {
        var r = b.getBoundingClientRect();
        // If the cart button is actually laid out (has size), anchor under it.
        if (r.width || r.height) {
          var right = Math.round(vw - r.right - 9);
          var maxRight = Math.max(8, vw - w - 8);
          box.style.top = Math.max(8, Math.round(r.bottom + 8)) + 'px';
          box.style.right = Math.min(maxRight, Math.max(5, right)) + 'px';
          box.style.left = 'auto';
          return;
        }
      }
      // Fallback: cart button missing or not yet laid out — pin to the top-right
      // corner so the card is ALWAYS visible rather than silently mispositioned.
      box.style.top = '68px';
      box.style.right = '12px';
      box.style.left = 'auto';
    }

    // ---- reservation helpers ----------------------------------------------
    var resvTick = null;   // interval handle
    // Start (or resume) the session countdown. Returns ms remaining, clamped >=0.
    function resvRemaining() {
      if (!RESV_ON) return null;
      if (RESV_PREVIEW) return 0;                // preview: force expired state
      if (RESV_DUR <= 0) return 0;               // 0 min -> immediately expired
      var s = ls(RESV_START);
      var start = s ? parseInt(s, 10) : NaN;
      if (isNaN(start)) { start = Date.now(); lsSet(RESV_START, String(start)); }
      var rem = RESV_DUR - (Date.now() - start);
      return rem > 0 ? rem : 0;
    }
    function mmss(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      var m = Math.floor(t / 60), s = t % 60;
      return m + ':' + (s < 10 ? '0' : '') + s;
    }
    // Paint the reservation tile. Live: RESERVED + countdown. When the timer runs
    // out the tile simply retires — no "ended" announcement (nothing real ends;
    // the cart is still there) and no crimson escalation. The card stays clean.
    function paintResv() {
      if (!box) return;
      var el = box.querySelector('[data-resv]');
      if (!el) return;
      if (!RESV_ON) { el.hidden = true; box.classList.remove('is-expired'); return; }
      var labelEl = el.querySelector('[data-resv-label]');
      var cueEl   = el.querySelector('[data-resv-cue]');
      var timeEl  = el.querySelector('[data-resv-time]');
      var msgEl   = el.querySelector('[data-resv-msg]');
      var rem = resvRemaining();
      if (rem <= 0) {
        // window closed: hide the tile and drop any escalation state.
        el.hidden = true;
        el.classList.remove('is-expired', 'is-flip');
        box.classList.remove('is-expired');
        if (msgEl) msgEl.textContent = '';
      } else {
        el.hidden = false;
        el.classList.remove('is-expired');
        box.classList.remove('is-expired');
        if (labelEl) labelEl.textContent = RESV_LABEL;  // inline label beside the clock
        if (cueEl)   cueEl.textContent   = '';          // no separate cue row
        if (timeEl)  timeEl.textContent  = mmss(rem);
      }
    }
    function startResvTick() {
      if (!RESV_ON || resvTick) return;
      resvTick = setInterval(function () {
        // keep the visible card in sync, and the sliver if it's showing
        if (box && box.classList.contains('is-in')) paintResv();
        if (sliver && sliver.classList.contains('is-in')) paintSliver();
        maybeResurface();
      }, 1000);
    }

    // ---- dismiss sliver ----------------------------------------------------
    var sliver = null;
    function buildSliver() {
      if (sliver) return;
      sliver = document.createElement('div');
      sliver.className = 'elio-cp__sliver';
      sliver.setAttribute('role', 'status');
      sliver.setAttribute('data-elio-dismissible', '');
      sliver.setAttribute('aria-live', 'polite');
      sliver.innerHTML =
        '<button type="button" class="elio-cp__sliver-x" aria-label="Dismiss">&times;</button>' +
        '<span class="elio-cp__sliver-body" data-sliver-body></span>';
      // tap the body -> bring the full card back (clears the dismissed flag)
      sliver.addEventListener('click', function () {
        ssDel(OFF);
        sliver.classList.remove('is-in');
        paint();
      });
      // tap the × -> dismiss the reminder entirely (persists across pages); don't reopen
      sliver.querySelector('.elio-cp__sliver-x').addEventListener('click', function (e) {
        e.stopPropagation();
        ssSet(SLIVER_OFF, '1');
        sliver.classList.remove('is-in');
      });
      document.body.appendChild(sliver);
      window.addEventListener('resize', anchorSliver);
      window.addEventListener('scroll', anchorSliver, { passive: true });
    }
    function anchorSliver() {
      if (!sliver) return;
      var b = document.getElementById('headerCartStatus');
      var vw = window.innerWidth, w = sliver.offsetWidth || 120;
      if (b) {
        var r = b.getBoundingClientRect();
        if (r.width || r.height) {
          var right = Math.round(vw - r.right - 9);
          var maxRight = Math.max(8, vw - w - 8);
          sliver.style.top = Math.max(8, Math.round(r.bottom + 8)) + 'px';
          sliver.style.right = Math.min(maxRight, Math.max(5, right)) + 'px';
          sliver.style.left = 'auto';
          return;
        }
      }
      // cart button missing/not laid out — pin top-right so it's never off-screen
      sliver.style.top = '68px';
      sliver.style.right = '12px';
      sliver.style.left = 'auto';
    }
    function paintSliver() {
      if (!sliver) return;
      var rem = resvRemaining();
      if (rem <= 0) {
        // window closed: retire the sliver quietly, no "ended" message.
        sliver.classList.remove('is-in', 'is-expired');
        return;
      }
      sliver.classList.remove('is-expired');
      var body = sliver.querySelector('[data-sliver-body]');
      if (body) body.innerHTML = esc(RESV_CUE) + '<span class="elio-cp__sliver-time">' + mmss(rem) + '</span>';
      anchorSliver();
    }
    function showSliver() {
      buildSliver();
      paintSliver();
      requestAnimationFrame(function () { sliver.classList.add('is-in'); });
    }
    // Once the card is dismissed and the countdown is inside the resurface window,
    // the sliver shows on EVERY page (like the full card) — not just once — until
    // the timer ends or the user closes it. It re-animates in only when it isn't
    // already showing, so it never re-pops on the same page.
    /* The collapsed form of the card. Independent of the resurface window,
       which exists for a different job: bringing the sliver back on subsequent
       page loads once the countdown is near its end. */
    function collapseToSliver() {
      if (ss(SLIVER_OFF) === '1') return;                        // they closed the sliver too
      if (sliver && sliver.classList.contains('is-in')) return;  // already collapsed
      if (RESV_ON && resvRemaining() != null && resvRemaining() <= 0) return; // hold expired
      showSliver();
    }

    function maybeResurface() {
      if (!RESV_ON || !off()) return;               // only while dismissed
      if (RESV_RESURF <= 0) return;                 // disabled
      if (RESV_RESURF > RESV_MIN) return;           // guard: can't exceed length
      if (ss(SLIVER_OFF) === '1') return;           // user closed it -> stays closed
      if (sliver && sliver.classList.contains('is-in')) return;  // already showing
      var rem = resvRemaining();
      if (rem == null) return;
      if (rem <= 0) return;                          // window closed; nothing to show
      if (rem <= RESV_RESURF * 60 * 1000) {
        showSliver();
      }
    }

    function build() {
      if (box) return;
      box = document.createElement('div');
      box.className = 'elio-cp';
      box.setAttribute('role', 'region');
      box.setAttribute('data-elio-dismissible', '');
      box.setAttribute('aria-label', CTA);
      box.innerHTML =
        '<button type="button" class="elio-cp__x" aria-label="Dismiss">&times;</button>' +
        '<div class="elio-cp__top">' +
          '<p class="elio-cp__claim" data-claim></p>' +
          '<div class="elio-cp__pair" data-pair></div>' +
        '</div>' +
        '<p class="elio-cp__colors" data-colors></p>' +
        '<p class="elio-cp__nudge" data-ship hidden></p>' +
        '<div class="elio-cp__resv" data-resv hidden>' +
          '<span class="elio-cp__resv-label" data-resv-label></span>' +
          '<span class="elio-cp__resv-cue" data-resv-cue></span>' +
          '<span class="elio-cp__resv-time" data-resv-time></span>' +
          '<span class="elio-cp__resv-msg" data-resv-msg></span>' +
        '</div>' +
        (RISK ? '<p class="elio-cp__risk"></p>' : '') +
        '<button type="button" class="elio-cp__cta"></button>' +
        '<button type="button" class="elio-cp__alt"></button>';
      document.body.appendChild(box);
      // Order flipped: the HERO slot (__claim) now carries the personalized line,
      // set dynamically in paint(); the secondary slot (__colors) carries the
      // static stand-in identity line beneath it.
      box.querySelector('[data-colors]').textContent = T_OTHER;
      if (RISK) box.querySelector('.elio-cp__risk').textContent = RISK;
      /* Primary goes STRAIGHT to checkout. The cart page doesn't upsell — the
         pair-capture there is hard-disabled (`if (false && ...)`) precisely so it
         doesn't detour checkout intent — so routing via /cart only added a click
         in front of the IC event. Secondary keeps the review path for anyone who
         wants it. */
      var cta = box.querySelector('.elio-cp__cta');
      cta.innerHTML = '<span class="elio-cp__cta-label"></span><span class="elio-cp__cta-total" data-cta-total></span>';
      cta.querySelector('.elio-cp__cta-label').textContent = CTA;
      cta.addEventListener('click', function () { if (window.elioCheckoutNudge && typeof window.elioCheckoutNudge.checkout === 'function') { window.elioCheckoutNudge.checkout({ source: 'header-cart-push' }); } else { goGuarded(checkoutUrl()); } });

      var alt = box.querySelector('.elio-cp__alt');
      alt.textContent = ALTCTA;

      /* Anywhere in the card that isn't the dismiss or the checkout button opens
         the side drawer. The card is a reminder of what's in the cart, so the
         whole surface should behave like the header cart button rather than
         only the one small secondary link. Same call the header uses, same
         fallback if the drawer element is missing. */
      box.addEventListener('click', function (e) {
        if (e.target.closest('.elio-cp__x, .elio-cp__cta')) return;
        e.preventDefault();
        openCartDrawer(e.target);
      });

      box.querySelector('.elio-cp__x').addEventListener('click', function () {
        ssSet(OFF, '1'); box.classList.remove('is-in');
        // a fresh dismiss re-enables the sliver (in case it was closed before).
        ssDel(SLIVER_OFF);
        /* Close means COLLAPSE, not dismiss. This used to call maybeResurface(),
           which bails when data-reserve-resurface-at is 0 — its default — so the
           card simply vanished. Collapsing is what the button means, so it is
           unconditional here: as long as the reserve is running and the shopper
           has not closed the sliver itself, the collapsed form takes over.
           maybeResurface() still governs later page loads, unchanged. */
        collapseToSliver();
      });
      window.addEventListener('resize', anchor);
      window.addEventListener('scroll', anchor, { passive: true });
    }

    function paint() {
      if (!showable() || off()) {
        if (box) box.classList.remove('is-in');
        // The sliver is only valid while the cart still qualifies (2+ items). If the
        // cart emptied or dropped below threshold, hide it and don't run the timer —
        // never show a reservation for a cart that isn't there.
        if (off() && count >= 2) { maybeResurface(); startResvTick(); }
        else if (sliver) sliver.classList.remove('is-in');
        return;
      }
      // Reservation window closed -> the whole nudge retires (card + sliver both
      // gone). Nothing real expires, so rather than announce anything, it simply
      // disappears until a cart change starts a fresh hold.
      if (RESV_ON && resvRemaining() <= 0) {
        if (box) box.classList.remove('is-in');
        if (sliver) sliver.classList.remove('is-in');
        return;
      }
      build();
      // full card is up -> the discreet sliver should never show alongside it
      if (sliver) sliver.classList.remove('is-in');
      box.querySelector('[data-pair]').innerHTML = thumbs();
      var lead = box.querySelector('[data-claim]');   // hero slot -> personalized line
      var cline = ownLine();
      // The claim is now JUST the personal object line ("Your Espresso & Crimson
      // briefs."). The reservation label moved onto the timer tile below, so the
      // sentence stays short and doesn't wrap awkwardly on the narrow mobile card.
      if (cline) {
        lead.innerHTML = cline; lead.hidden = false;
      } else { lead.innerHTML = ''; lead.hidden = true; }
      var ship = box.querySelector('[data-ship]');
      var low  = lowLine();
      var line = low || shipLine();
      if (line) {
        ship.textContent = line; ship.hidden = false;
        ship.classList.toggle('is-low', !!low);   // low stock -> crimson; ship cue -> default
      }
      else      { ship.textContent = '';    ship.hidden = true; ship.classList.remove('is-low'); }
      paintResv();
      var ctaTotal = box.querySelector('[data-cta-total]');
      if (ctaTotal) ctaTotal.textContent = money(cartTotal) || '';

      /* Savings line. Leads with the amount saved and a verb, because
         "TAKE10 · $4.10" beside a total reads as a price, not a discount.
         The codes follow as attribution. Removed entirely when nothing is
         applied — no empty row. */
      var saveEl = box.querySelector('[data-elio-cp-saved]');
      if (cartSavedTotal > 0) {
        if (!saveEl) {
          saveEl = document.createElement('div');
          saveEl.setAttribute('data-elio-cp-saved', '');
          saveEl.className = 'elio-cp__saved';
          if (ctaTotal && ctaTotal.parentNode) {
            ctaTotal.parentNode.parentNode.insertBefore(saveEl, ctaTotal.parentNode.nextSibling);
          } else { box.appendChild(saveEl); }
        }
        /* Present tense: nothing has been bought yet, so "saved" is wrong.
           Stacked rather than inline — the amount is the message and the
           attribution is a footnote, not a peer. */
        /* Reads as something the shopper HAS, not as an accounting line.
           The money leads and "off applied" confirms it is already theirs —
           "You're saving $11.10 / PAIR DISCOUNT + TAKE10" described a
           calculation instead of handing them a benefit. */
        /* $35.8 was rendering with a single decimal. Format explicitly: whole
           amounts stay clean, anything else gets exactly two places. */
        saveEl.innerHTML = '';
        var amt = document.createElement('span');
        amt.className = 'elio-cp__saved-amt';
        /* Plain and unambiguous. "Off applied" described a mechanic and
           "secured" made the reader decode a metaphor; this just says what is
           happening to their money. */
        amt.textContent = "You're saving " + money(cartSavedTotal);
        saveEl.appendChild(amt);
        if (cartSavedNames.length) {
          var src = document.createElement('span');
          src.className = 'elio-cp__saved-src';
          src.textContent = cartSavedNames.join(' + ');
          saveEl.appendChild(src);
        }
      } else if (saveEl && saveEl.parentNode) {
        saveEl.parentNode.removeChild(saveEl);
      }
      startResvTick();
      anchor();
      box.classList.add('is-in');
    }

    var latestCartRead = 0;
    function applyCart(c) {
      if (!c) return;
      mergeLiveVariants();
      // The header count must never depend on the (now-suppressed) notification
      // opening or on a shipping-meter component mounting on this page.
      var header = document.getElementById('headerCartStatus');
      if (header && typeof c.item_count === 'number') {
        var nBadge = Math.max(0, c.item_count);
        var digit = header.querySelector('.cart-count-number');
        var bubble = header.querySelector('.header__cart-count');
        if (digit && digit.textContent.trim() !== String(nBadge)) digit.textContent = String(nBadge);
        if (bubble) {
          bubble.classList.toggle('opacity-0', !nBadge);
          bubble.classList.toggle('hidden-xs', !nBadge);
          var oldBadgeClass = Array.from(bubble.classList).find(function (name) {
            return /^header-cart-count-\d+$/.test(name);
          });
          var newBadgeClass = 'header-cart-count-' + nBadge;
          if (oldBadgeClass && oldBadgeClass !== newBadgeClass) bubble.classList.replace(oldBadgeClass, newBadgeClass);
          else if (!oldBadgeClass) bubble.classList.add(newBadgeClass);
        }
        var hiddenLabels = header.querySelectorAll('.visually-hidden');
        var countLabel = hiddenLabels.length > 1 ? hiddenLabels[hiddenLabels.length - 1] : null;
        if (countLabel) {
          var labelText = countLabel.textContent || '';
          var labelUpdated = /\d+/.test(labelText) ? labelText.replace(/\d+/, String(nBadge)) : (nBadge + ' items in cart');
          if (labelUpdated !== labelText) countLabel.textContent = labelUpdated;
        }
      }
      {
            var n = +c.item_count || 0;
            var prev = ss(LAST);
            if (prev !== null && n !== +prev) {
              ssDel(OFF);                 // cart changed -> resurface the card
              // a changed cart is a fresh hold: restart the countdown and clear the
              // sliver-closed flag so it can reappear for the new state.
              lsDel(RESV_START);
              ssDel(SLIVER_OFF);
              if (sliver) sliver.classList.remove('is-in', 'is-expired');
              var r = box && box.querySelector('[data-resv]');
              if (r) r.classList.remove('is-expired', 'is-flip');
            }
            ssSet(LAST, String(n));
            count = n; items = c.items || [];
            cartTotal = (typeof c.total_price === 'number') ? c.total_price : null;
            /* Savings from the same payload as the total, so the two can never
               disagree. Cart-level and line-level allocations are summed per
               title — a bundle spread over two lines counts once. */
            (function () {
              var by = {}, order = [];
              function add(t, a) {
                a = Number(a || 0);
                if (!t || a <= 0) return;
                if (by[t] === undefined) { by[t] = 0; order.push(t); }
                by[t] += a;
              }
              (c.cart_level_discount_applications || []).forEach(function (d) {
                if (d) add(d.title, d.total_allocated_amount);
              });
              (c.items || []).forEach(function (it) {
                (it.line_level_discount_allocations || []).forEach(function (al) {
                  if (al) add(al.discount_application && al.discount_application.title, al.amount);
                });
              });
              // The drawer uses this exact difference for its savings row.
              // Allocations are only useful to name the savings, not to total them.
              // In particular, stacked code + automatic discounts can have
              // different allocations from a freshly applied cart discount.
              if (typeof c.original_total_price === 'number' && typeof c.total_price === 'number') {
                cartSavedTotal = Math.max(0, c.original_total_price - c.total_price);
              } else {
                cartSavedTotal = Math.max(0, Number(c.total_discount) || 0);
              }
              cartSavedNames = order;
            })();
            cartCurrency = c.currency || cartCurrency;
          }
      paint();
    }

    function read() {
      var myRead = ++latestCartRead;
      return fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (myRead !== latestCartRead || !cart) return;
          applyCart(cart);
        })
        .catch(function () {});
    }

    // Reuse the cart-state component's authoritative cart response rather than
    // keeping an independent price snapshot alive after discount changes.
    document.addEventListener('elio:cart:state', function (event) {
      if (!event.detail || !event.detail.cart) return;
      ++latestCartRead;
      applyCart(event.detail.cart);
    });

    // Debug hook: run  __elioCp()  in the console to see exactly why a slot fired.
    window.__elioCp = function () {
      mergeLiveVariants();
      var out = {
        mapSize: Object.keys(STOCK).length,
        hasLiveMap: !!document.querySelector('[data-product-variants]'),
        lowThreshold: LOW_MAX,
        cartCount: count,
        items: items.map(function (it) {
          var id = it.variant_id != null ? it.variant_id : it.id;
          var r = STOCK[String(id)];
          return {
            title: it.product_title + ' / ' + it.variant_title,
            variant_id: id,
            foundInMap: !!r,
            qty: r ? r.q : null,
            inventory_management: r ? r.m : null,
            inventory_policy: r ? r.p : null,
            counts: isTracked(r)
          };
        }),
        slot1_lowLine: lowLine(),
        slot2_shipLine: shipLine(),
        slot3_default: T_OTHER,
        RENDERS: urgencyLine()
      };
      console.table(out.items);
      console.log(out);
      return out;
    };

    // This theme dispatches NO cart events (no cart:update / cart:updated / etc),
    // so listening for them never fires. Watch what actually changes instead:
    //   1. the cart requests themselves (fetch + XHR)
    //   2. the header cart badge the theme rewrites
    // Belt and braces: either one alone is enough, together they can't miss.
    var pending = null;
    function reread() {
      clearTimeout(pending);
      pending = setTimeout(read, 120);        // debounce: one read per burst
    }

    // The theme's sticky header can spuriously "reveal" (slide down) when the
    // drawer re-renders after an in-cart operation — removing an item, or nudging
    // the quantity. While the drawer is open the header sits behind the overlay,
    // so a reveal is never wanted here. Briefly no-op the sticky header's reveal
    // around change/update/clear (NOT add — add-to-cart's reveal is intentional).
    function suppressStickyReveal() {
      var sticky = document.querySelector('sht-sticky-header');
      if (!sticky || typeof sticky.reveal !== 'function' || sticky.__elioRevealGuarded) return;
      sticky.__elioRevealGuarded = true;
      var real = sticky.reveal;
      sticky.reveal = function () {};
      setTimeout(function () {
        try { sticky.reveal = real; } catch (e) {}
        sticky.__elioRevealGuarded = false;
      }, 700);
    }

    // 1a. fetch
    if (window.fetch && !window.__ELIO_CP_FETCH__) {
      window.__ELIO_CP_FETCH__ = true;
      var _fetch = window.fetch;
      window.fetch = function (input) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var p = _fetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(reread, function () {});
          if (/\/cart\/(change|update|clear)/.test(url)) suppressStickyReveal();
        }
        return p;
      };
    }
    // 1b. XHR, in case anything on the theme still uses it
    if (window.XMLHttpRequest && !window.__ELIO_CP_XHR__) {
      window.__ELIO_CP_XHR__ = true;
      var _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        if (/\/cart\/(add|change|update|clear)/.test(String(url || ''))) {
          this.addEventListener('load', reread);
        }
        return _open.apply(this, arguments);
      };
    }

    // 2. the badge: whatever the theme does, it must update this
    var badge = document.getElementById('headerCartStatus');
    if (badge && window.MutationObserver) {
      new MutationObserver(reread).observe(badge, {
        childList: true, subtree: true, characterData: true, attributes: true
      });
    }

    // the notification tells us when it's gone — repaint then
    var notif = document.getElementById('cartNotificationPanel');
    if (notif) {
      notif.addEventListener('closed', function () { setTimeout(paint, 60); });
      if (window.MutationObserver) {
        new MutationObserver(function () { paint(); })
          .observe(notif, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    // still honour real events if any app/theme ever fires them
    ['cart:update','cart:updated','cart:change','cart:refresh','ajaxCart.afterCartLoad']
      .forEach(function (e) {
        document.addEventListener(e, function () {
          reread();
          if (e === 'cart:refresh') setTimeout(read, 550);
        });
      });
    window.addEventListener('pageshow', read);
    // An idle/background tab never sees a cart emptied elsewhere (checkout in another
    // tab, cookie expiry) — so its timer keeps ticking on a stale count. Re-read the
    // cart whenever the tab regains focus so it catches up and clears if empty.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) read();
    });

    read();
    // Resilience: header/cart elements can mount late, and the notification grace
    // window needs a re-check after it lapses. Re-read a few times after load so
    // the push reliably appears without depending on a single early tick.
    [400, 1200, 3000, 6500].forEach(function (ms) { setTimeout(read, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
